import React from "react";
import PixelRealmPage from "./PixelRealmPage";

/**
 * Pixel 宇宙 — 与 cyber-uni / noir-uni 并列的独立主题站入口。
 */
export default function PixelUniPage() {
  return <PixelRealmPage />;
}
